import { useEffect, useState } from 'react';
import VigoOrderStatusPanel, { VigoOrderStatusPanelProps } from 'src/@vigo/vigo-orderstatuspanel';
import VigoSpinner from 'src/@vigo/vigo-spinner';
import { useAppSelector } from 'src/store/baseHooks';

const OrderListStatusPanel = ({ isOpen: isOpenProp }: { isOpen?: boolean }) => {
  // State
  const [panelContent, setPanelContent] = useState<VigoOrderStatusPanelProps>();

  // Hooks
  const additionalDataTransferObject = useAppSelector(
    state => state.uiflow.additionalDataState.additionalDataTransferObject
  );

  const isOpenFromRedux = useAppSelector(
    state =>
      state.uiflow.additionalDataState.additionalDataPanels.find(p => p.id === 'OrderListStatusPanel')?.open ?? false
  );

  // When rendered inside StatusHistoryDrawer an isOpen prop is provided.
  // When rendered via the AdditionalData panel system it falls back to Redux state.
  const isOpen = isOpenProp !== undefined ? isOpenProp : isOpenFromRedux;

  useEffect(() => {
    if (isOpen && additionalDataTransferObject.statusPanelProps) {
      setPanelContent(additionalDataTransferObject.statusPanelProps);
    } else if (!isOpen) {
      setPanelContent(undefined);
    }
  }, [additionalDataTransferObject.statusPanelProps, isOpen]);

  return (
    <>
      {!panelContent && <VigoSpinner customSx={{ height: '60vh' }} name="orderListStatusPanelSpinner" />}
      {panelContent && (
        <VigoOrderStatusPanel
          {...{
            ...panelContent
          }}
        />
      )}
    </>
  );
};

export default OrderListStatusPanel;
